<template>
  <svg
    :width="width ? width : height ? height : 35"
    :height="height ? height : width ? width : 30"
    viewBox="0 0 35 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >

    <path
      d="M10.206 11.952v5.819c0 .48-.67 1.163-1.163 1.163H2.06c-.494 0-1.164-.683-1.164-1.163v-5.82c0-.48.67-1.163 1.164-1.163h6.983c.494 0 1.163.684 1.163 1.164zM.896 22.426v5.819c0 .48.67 1.164 1.164 1.164h6.983c.494 0 1.163-.684 1.163-1.164v-5.82c0-.48-.67-1.163-1.163-1.163H2.06c-.494 0-1.164.684-1.164 1.164zM9.043.314H2.06C1.566.314.896.998.896 1.477v5.82c0 .48.67 1.163 1.164 1.163h6.983c.494 0 1.163-.684 1.163-1.164V1.477c0-.48-.67-1.163-1.163-1.163zm4.655 29.095h19.784c.446 0 1.164-.684 1.164-1.164v-5.82c0-.48-.718-1.163-1.164-1.163H13.698c-.445 0-1.164.684-1.164 1.164v5.819c0 .48.719 1.164 1.164 1.164zM12.534 1.477v5.82c0 .48.719 1.163 1.164 1.163h19.784c.446 0 1.164-.684 1.164-1.164V1.477c0-.48-.718-1.163-1.164-1.163H13.698c-.445 0-1.164.684-1.164 1.163zm1.164 17.457h19.784c.446 0 1.164-.683 1.164-1.163v-5.82c0-.48-.718-1.163-1.164-1.163H13.698c-.445 0-1.164.684-1.164 1.164v5.819c0 .48.719 1.163 1.164 1.163z"
      :fill="iconColor"
      fill-rule="nonzero"
    />

  </svg>
</template>

<script>
export default {
  name: 'filled-circle-pen',
  props: {
    iconColor: {
      type: String,
      default: '#ffffff',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
